import React, { useState } from 'react';
import { BlockStack, Button, Card, DataTable, Icon, InlineGrid, InlineStack, Spinner, Text } from '@shopify/polaris';
import PageHeader from '../page_header';
import { useFetchAnalytics } from '../dashboard/api';
import PropTypes from "prop-types";
import {
  InfoIcon
} from '@shopify/polaris-icons';
import { useFetchPayouts, usePayoutEmail } from './api';
import ToastMessage from '../common/ToastMessage';
import { useFetchSettingsData } from '../settings/api';
import * as styles from "./index.module.scss";
import { useAxiosInstance } from '../../context/AxiosContext';

const THRESHOLD_AMOUNT = 25;

const PaypalBody = ({ amount }) => {
  if (amount > THRESHOLD_AMOUNT) {
    return (
      <BlockStack gap={200}>
        <Text fontWeight="bold">
          PayPal
        </Text>
        <div
          className={styles.imageContainer}
        >
          <img
            className={styles.fullImageStyle}
            src="data:image/jpeg;base64,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"
            alt="Paypal Logo"
          />
        </div>
      </BlockStack>
    );
  }
  return (
    <InlineGrid columns={{ xs: "1fr 8fr", md: "1fr 20fr" }}
    >
      <Icon
        source={InfoIcon}
        tone="base"
      />
      <Text tone="subdued">
        To request a payout, your total earnings must meet a minimum threshold of $25.00 USD.
      </Text>
    </InlineGrid>
  );
};

const Payouts = () => {
  const axiosInstance = useAxiosInstance();
  const { data: analytics, isLoading: analyticsLoading } = useFetchAnalytics({ axiosInstance });
  const { data, isLoading } = useFetchPayouts({ axiosInstance });
  const { data: settings, isLoading: settingLoading } = useFetchSettingsData({ axiosInstance });
  const { mutate } = usePayoutEmail({
    axiosInstance,
    onSuccess: () => {
      setToast({
        active: true,
        content: "Notification sent successfully"
      });
    }
  });
  const [toast, setToast] = useState({
    active: false,
    content: ""
  });
  let rows = isLoading || !data?.data ? [] : data.data;

  const handlePayout = () => {
    if (!settingLoading && (!settings.data.paypal_email)) {
      setToast({
        active: true,
        content: "Update PayPal email in settings"
      });
      return;
    }
    mutate();
  };

  const handleToast = () => {
    setToast({
      active: false,
      content: ""
    });
  };
  return (
    <BlockStack gap={400}>
      <PageHeader title="Payouts" />
      <Card>
        <BlockStack gap={200} align="center">
          <InlineStack align="space-between" blockAlign="center">
            <Text fontWeight="bold">Request payout</Text>
            <InlineStack gap={200}>
              <Text tone="subdued">
                Unpaid earnings
              </Text>
              {
                analyticsLoading ?
                  <Spinner /> :
                  <Text variant='heading2xl'>${Number(analytics.pending_commissions || 0).toFixed(2)}</Text>
              }
            </InlineStack>
          </InlineStack>
          <Card>
            <InlineStack align="space-between" blockAlign="center">
              {
                analyticsLoading ?
                  <Spinner /> :
                  <>
                    <PaypalBody amount={analytics.pending_commissions} />
                    <div
                      className={styles.buttonHeight}
                    >
                      <Button
                        size="micro"
                        disabled={analytics.pending_commissions < THRESHOLD_AMOUNT}
                        onClick={handlePayout}
                      >Request payout
                      </Button>
                    </div>
                  </>
              }
            </InlineStack>
          </Card>
        </BlockStack>
      </Card>
      <Card padding={0}>
        <DataTable
          columnContentTypes={[
            'text',
            'text',
            'text',
          ]}
          headings={[
            <Text fontWeight="bold" key={1}>Payout date</Text>,
            <Text fontWeight="bold" key={2}>Payout amount</Text>,
            <Text fontWeight="bold" key={3}>Payout method</Text>,
          ]}
          rows={rows}
          footerContent={rows.length === 0 ? <Text>Your payouts will be displayed here</Text> : null} // Optional footer message
        />
      </Card>
      {
        toast.active && <ToastMessage isActive={toast.active} content={toast.content} onDismiss={handleToast} />
      }
    </BlockStack>
  );
};

PaypalBody.propTypes = {
  amount: PropTypes.any,
};

export default Payouts;